import { Dialog } from '@noorden-insurtech/alba-design-system';
import type { ReactNode } from 'react';

const SIZE_CLASSES: Record<'md' | 'lg', string> = {
  md: 'w-[480px] max-w-[90vw]',
  lg: 'w-[640px] max-w-[90vw]',
};

export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  /** Texto curto abaixo do título. */
  description?: ReactNode;
  children: ReactNode;
  /** Botões de ação, alinhados à direita. */
  footer?: ReactNode;
  /** Enquanto `true`, fechar por fora (Esc, clique no fundo) é ignorado. */
  isBusy?: boolean;
  size?: 'md' | 'lg';
};

/**
 * Diálogo genérico — formulário ou conteúdo em sobreposição. Para ação
 * sensível que pede a digitação de uma palavra, use o `ConfirmActionModal`.
 * Envolve o `Dialog` do design system, que está saindo: features importam
 * daqui, nunca do pacote.
 */
export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  footer,
  isBusy = false,
  size = 'md',
}: ModalProps) {
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open && !isBusy) onClose();
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className={SIZE_CLASSES[size]}>
          <Dialog.Header>
            <Dialog.Title>{title}</Dialog.Title>
          </Dialog.Header>

          <Dialog.Body className='flex flex-col gap-4'>
            {description && (
              <div className='text-sm text-alba-gray-700'>{description}</div>
            )}
            {children}
          </Dialog.Body>

          {footer && (
            <Dialog.Footer className='flex justify-end gap-2'>
              {footer}
            </Dialog.Footer>
          )}
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
